import { DocumentListItem } from '../document-list/document-list-models';

export interface ISelectDocumentDialogParams {
  targetOrganisationGid: string;
  context: string;
}

export class SelectDocumentDialogParams implements ISelectDocumentDialogParams {
  public targetOrganisationGid: string;
  public context: string;

  constructor(values: ISelectDocumentDialogParams) {
    this.targetOrganisationGid = values.targetOrganisationGid;
    this.context = values.context;
  }
}

export class SelectDocumentDialogResult {
  public ok: boolean;
  public selectedDocuments: DocumentListItem[];

  constructor(values: Partial<SelectDocumentDialogResult>) {
    this.ok = values.ok ?? false;
    this.selectedDocuments = values.selectedDocuments ?? [];
  }
}

export class SelectDocumentDialog {
  public open!: (params: SelectDocumentDialogParams) => Promise<SelectDocumentDialogResult>;
}
